import { render, staticRenderFns } from "./IdcList.vue?vue&type=template&id=d767fec4&"
import script from "./IdcList.vue?vue&type=script&lang=js&"
export * from "./IdcList.vue?vue&type=script&lang=js&"
import style0 from "./IdcList.vue?vue&type=style&index=0&lang=less&"
import style1 from "./IdcList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports